import React from 'react';

import Header from '../../Components/Dashboard/Header/Header';
import Locations from '../../Components/Dashboard/Admin/Locations/List';


export default function LocationsPage() {
  return (
    <>
      <Header/>
      <div className="body">
        <Locations/>
      </div>
    </>
  );
}
